import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_274: DocMigration = {
  maxSchemaVersion: "0.0.274",
  description: "Move Vent Settings to roofSideOverrides",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofSettings = {} } = roof;
      let { roofSideOverrides = {} } = roof;
      const { includeTriangleGableVent, triangleGableVentBaseWidth } = roofSettings;
      roofSideOverrides = {
        ...roofSideOverrides,
        START: {
          ...roofSideOverrides.START,
          includeTriangleGableVent,
          triangleGableVentBaseWidth,
        },
        END: {
          ...roofSideOverrides.END,
          includeTriangleGableVent,
          triangleGableVentBaseWidth,
        },
      };

      delete roofSettings.includeTriangleGableVent;
      delete roofSettings.triangleGableVentBaseWidth;

      roofs[id] = {
        ...roof,
        roofSideOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_274;
